import React from "react";
import Grid from "../layout/grid";
import SimpleCurrencyInput from "react-simple-currency";

export default (props) => {
  let labelFloat = null;
  let labelCol = props.labelCol ? props.labelCol : 6;
  let inputCol = 12 - labelCol;
  if (props.labelFloat) {
    labelFloat = props.labelFloat;
  } else {
    props.orientation == "landscape" ? "right" : "unset";
  }

  let labelColClasses = `col-md-${labelCol} col-sm-${labelCol} col-xs-${labelCol}`;
  let inputColClasses = `col-md-${inputCol} col-sm-${inputCol} col-xs-${inputCol}`;

  return (
    <Grid cols={props.cols}>
      {/* <div className='form-group'> */}
      <div
        className={labelColClasses}
        style={
          props.orientation == "landscape"
            ? { float: "left" }
            : { padding: "0 5px 0 0" }
        }
      >
        <label
          htmlFor={props.name}
          style={{ float: labelFloat, fontSize: "15px", marginTop: "10px" }}
        >
          {props.label}
        </label>
      </div>
      <div
        className={`${inputColClasses} nopadding`}
        style={{ display: "flex" }}
      >
        <SimpleCurrencyInput
          id={props.id}
          precision={2}
          className="form-control"
          separator=","
          delimiter="."
          value={props.value}
          onInputChange={props.onChange}
          onInputBlur={props.onBlur}
        />
      </div>
      {/* </div> */}
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/common/form/labelAndMoney.jsx